import MkuOptions from '../select/src/options';

MkuOptions.install = function (Vue) {
  Vue.component(MkuOptions.name, MkuOptions);
};

export default MkuOptions;
